// src/helpers/sdr_report_helper.js
import axios from "axios";
import * as url from "./url_helper";

// ============================
// GENERATE SDR REPORT - ALL STUDENTS
// ============================
export const generateSdrReport = async (params) => {
    console.log("📤 Generating SDR Report (All Students):", params);
    
    try {
        const response = await axios({
            method: 'get',
            url: url.SDR_REPORT,
            params: params,
            responseType: 'blob',
            timeout: 600000
        });
        return response;
    } catch (error) {
        console.error("❌ Error generating SDR Report:", error);
        throw error;
    }
};

// ============================
// GENERATE SDR REPORT - NEVER ENROLLED
// ============================
export const generateNeverEnrolledReport = async (params) => {
    console.log("📤 Generating Never Enrolled Students Report:", params);
    
    try {
        const response = await axios({
            method: 'get',
            url: url.SDR_NEVER_ENROLLED,
            params: params,
            responseType: 'blob',
            timeout: 600000
        });
        return response;
    } catch (error) {
        console.error("❌ Error generating Never Enrolled Report:", error);
        throw error;
    }
};

// ============================
// GET DISTINCT STATES
// ============================
export const getSdrStates = async (organizationId) => {
    try {
        const response = await axios.get(url.SDR_STATES, {
            params: { organizationId: organizationId || 1 }
        });
        console.log("📥 States response:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching states:", error);
        return [];
    }
};

// ============================
// GET DISTINCT DEPOTS
// ============================
export const getSdrDepots = async (organizationId) => {
    try {
        const response = await axios.get(url.SDR_DEPOTS, {
            params: { organizationId: organizationId || 1 }
        });
        console.log("📥 Depots response:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching depots:", error);
        return [];
    }
};

// ============================
// GET DISTINCT COURSES
// ============================
export const getSdrCourses = async (organizationId) => {
    try {
        const response = await axios.get(url.SDR_COURSES, {
            params: { organizationId: organizationId || 1 }
        });
        console.log("📥 Courses response:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching courses:", error);
        return [];
    }
};